import { Select, SelectProps } from '@mantine/core';

const STATE_OPTIONS = [
	{ value: 'ACT', label: 'ACT' },
	{ value: 'NSW', label: 'NSW' },
	{ value: 'NT', label: 'NT' },
	{ value: 'QLD', label: 'QLD' },
	{ value: 'SA', label: 'SA' },
	{ value: 'TAS', label: 'TAS' },
	{ value: 'VIC', label: 'VIC' },
	{ value: 'WA', label: 'WA' },
];

export const StateInput = (props: SelectProps) => {
	return <Select data={STATE_OPTIONS} {...props} />;
};
